import React, { Suspense, lazy, useState, useContext } from "react";
import { A11yFloatingPanel } from "./A11yFloatingPanel.jsx";
import { KeyboardHelpModal } from "./KeyboardHelpModal.jsx";
import { ReadingMask } from "./ReadingMask.jsx";
import { useGlobalShortcuts } from "../hooks/useGlobalShortcuts.js";
import { useTts } from "../hooks/useTts.js";
import { useA11y } from "../hooks/useA11y.js";
import { LangContext } from "../../context/LangContext.js";

const LazyDyslexiaFontLoader = lazy(() =>
  import("./DyslexiaFontLoader.jsx").then((m) => ({
    default: m.DyslexiaFontLoader,
  })),
);
const LazyReadingGuide = lazy(() =>
  import("./ReadingGuide.jsx").then((m) => ({ default: m.ReadingGuide })),
);

export function A11yShell() {
  const [helpOpen, setHelpOpen] = useState(false);
  const a11y = useA11y();
  const lang = useContext(LangContext);
  const nep = !!(lang && lang.state && lang.state.np);

  const ttsEnabled = a11y.settings && a11y.settings.ttsEnabled;
  const hoverRead = a11y.settings && a11y.settings.hoverReadEnabled;
  useTts({ isNepali: nep, enabled: ttsEnabled, hoverEnabled: hoverRead });

  useGlobalShortcuts({
    onHelp: () => setHelpOpen(true),
    onSkipToMain: () => {
      if (typeof document === "undefined") return;
      const el = document.getElementById("main");
      if (!el) return;
      try {
        el.focus({ preventScroll: true });
      } catch (e) {
        try {
          el.focus();
        } catch (err) {}
      }
      if (typeof el.scrollIntoView === "function")
        el.scrollIntoView({ block: "start" });
    },
  });

  return (
    <>
      <Suspense fallback={null}>
        <LazyDyslexiaFontLoader />
        <LazyReadingGuide />
      </Suspense>
      <ReadingMask />
      <A11yFloatingPanel onOpenHelp={() => setHelpOpen(true)} />
      <KeyboardHelpModal open={helpOpen} onClose={() => setHelpOpen(false)} />
    </>
  );
}

export default A11yShell;
